/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC content is the percentage of a sequence made up of guanine and cytosine. It is calculated as (G + C) divided by the total number of bases, times 100.`)
};

const es_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El contenido GC es el porcentaje de una secuencia compuesto por guanina y citosina. Se calcula como (G + C) dividido entre el número total de bases, multiplicado por 100.`)
};

const de_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der GC-Gehalt ist der Prozentsatz einer Sequenz, der aus Guanin und Cytosin besteht. Er wird berechnet als (G + C) geteilt durch die Gesamtzahl der Basen, mal 100.`)
};

const nl_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-gehalte is het percentage van een sequentie dat bestaat uit guanine en cytosine. Het wordt berekend als (G + C) gedeeld door het totale aantal basen, maal 100.`)
};

const fr_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le contenu GC est le pourcentage d'une séquence composé de guanine et de cytosine. Il est calculé comme (G + C) divisé par le nombre total de bases, multiplié par 100.`)
};

const it_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il contenuto GC è la percentuale di una sequenza costituita da guanina e citosina. Si calcola come (G + C) diviso il numero totale di basi, moltiplicato per 100.`)
};

const pt_br2_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo GC é o percentual de uma sequência composto por guanina e citosina. É calculado como (G + C) dividido pelo número total de bases, multiplicado por 100.`)
};

const pt_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conteúdo GC é a percentagem de uma sequência composta por guanina e citosina. É calculado como (G + C) dividido pelo número total de bases, vezes 100.`)
};

const ja_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC含量は、配列中でグアニンとシトシンが占める割合です。(G + C) を塩基の総数で割り、100を掛けて計算されます。`)
};

const zh_gc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 含量是序列中由鸟嘌呤和胞嘧啶组成的百分比。计算方法为 (G + C) 除以碱基总数，再乘以 100。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_a1", locale)
	if (locale === "en") return en_gc_faq_a1(inputs)
	if (locale === "es") return es_gc_faq_a1(inputs)
	if (locale === "de") return de_gc_faq_a1(inputs)
	if (locale === "nl") return nl_gc_faq_a1(inputs)
	if (locale === "fr") return fr_gc_faq_a1(inputs)
	if (locale === "it") return it_gc_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_a1(inputs)
	if (locale === "pt") return pt_gc_faq_a1(inputs)
	if (locale === "ja") return ja_gc_faq_a1(inputs)
	return zh_gc_faq_a1(inputs)
};